<template id=login>
  <div class="login-container">

    <div class="d-flex m-auto p-5 justify-content-center flex-column login">
      <b-overlay :show="show" rounded="lg">
        <h1>Login</h1>
        <form action="" name="cform" v-on:submit="login()">
          <div class="form-group">
            <label for="exampleInputEmail0" class="float-left">User Name</label>
            <input type="text" class="form-control"
                   id="exampleInputEmail0" aria-describedby="emailHelp"
                   v-model="f.userName"
                   required
                   placeholder="Enter your UserName">

          </div>
          <div class="form-group">
            <label for="exampleInputEmail1" class="float-left">Password</label>
            <input type="password" class="form-control"
                   id="exampleInputEmail1" aria-describedby="emailHelp"
                   v-model="f.password"
                   required
                   placeholder="Enter your Password">

          </div>
         <!-- <div class="form-group">
            <div :class="{mx_recaptcha_failed: !recaptcha}">
              <vue-recaptcha
                  sitekey="6Ld_kUEdAAAAAFSKZIM8s70FU_z0z0fFNFdCxv4Z"
                  @verify="mxVerify"></vue-recaptcha>
            </div>
          </div>-->


          <!--Alert Message-->

          <div class="alert alert-danger" v-if="$store.state.serverIsDown">Server Seems to be down.</div>
          <div class="alert alert-danger" v-if="$store.state.serverIsDown">Please Contact Administrator
          </div>
          <div class="alert alert-danger" v-if="loginFailed">{{ errorTitle }}
          </div>
         <!-- <div class="alert alert-danger" v-if="!recaptcha">{{ errorCheckbox }}
          </div>-->

          <button type="button" v-on:click="login()" class="btn btn-primary float-lg-left">
            Login
          </button>

          <!--Role Switch After login button is Clicked-->
          <!--<div class="float-left">
              <label style="margin-right: 100px">Select Role</label>
              <v-select v-model="roles" :options="roleName"></v-select>
              <br>
              <button class="btn btn-primary btn-sm float-left" v-on:click="selectRole(roles)">
                  Proceed
              </button>
          </div>-->
        </form>
      </b-overlay>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
//import Vue from 'vue'
//import VueRecaptcha from 'vue-recaptcha'

//  let jwtDecode = require('jwt-decode')
//Vue.component('vue-recaptcha', VueRecaptcha)
export default {
  name: 'login',
  data() {
    return {
      show: false,
      f: {
        userName: '',
        password: '',
      },
      loginFailed: false,
      checkingLogin: true,
      serverDown: this.$store.state.serverIsDown,
      roleData: [],
      roleName: [],
      roles: [],
     // recaptcha: null,
      errorCheckbox: "Please check the CheckBox"
    }
  },

  created: function () {

    if (this.$store.state.isLoggedIn) {
      //no need to login again
      this.$router.push('/')
    }
  },
  methods: {
    async login() {
      this.loginFailed = false
      this.$store.state.authRequired = false
      this.show = true
      try {
        let response = await axios.post(`/auth/login`, this.f)

        await this.handleLogin(response.data)
      } catch (error) {
        this.errorTitle = error.response && error.response.data ? error.response.data.error : 'Something went wrong'
        await this.$store.commit('authError')
        this.loginFailed = !this.$store.state.serverIsDown
        this.show = false
      }


    },
    async handleLogin(response) {
      if (response['authToken']) {
        await this.$store.commit('loggedIn', response['authToken'])

        await this.$store.dispatch('checkUserLogin')
        await this.$store.dispatch("loadState")
        await this.$store.dispatch('loadAnnotations')
        console.info('annotations loaded')
        console.info('user loaded')
        this.show = false
        // console.log("User info",this.$store.state.user)
        if(this.$store.state.user.enforcePasswordReset){
          await this.$router.push('/change-password')
        }
        else{
          await this.$router.push('/')
        }

      } else {
        console.error('Login Failed?', response)
        this.loginFailed = true
        this.show = false
      }
    },
    // mxVerify(res) {
    //
    //   this.recaptcha = res
    //
    // },
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  width: 100vh;
  height: 75vh;
  justify-content: center;
  align-content: center;
  align-items: center;
  align-self: center;
}

.login {
  box-shadow: 1px 2px 2px 3px #a7aeaa;
}

.role-container {
  justify-content: center;
  align-content: center;
  align-items: center;
  align-self: center;
}

.login {
  box-shadow: 1px 2px 2px 3px #a7aeaa;
}

</style>
